import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, formatNumber, isNotEmpty, getRemotedbUrl } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';
import { stage_promotion_types as spt } from '../../data/bootstrap_stages.js';

import ActionLink from '../builder/ActionLink';
import ActionButton from '../builder/ActionButton';
import Message from '../builder/Message.js';
import Spinner from '../builder/Spinner';

import UserAvatar, { UploadAvatar } from './UserAvatar';
import FloatingLayerPublic from './FloatingLayerPublic';
import XeerpaDiscovery from './XeerpaDiscovery';

import UserParticipationsMultistageList from './layers/UserParticipationsMultistageList';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';
import { formatTokenTitle } from './loyalty/TokenAmount.js';

const MyParticipationMultistage = (props) => {
	useCSS('comp/my_participation.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const promotion = props?.promotion?.Promotion ?? false;
	const _participations = props?.participations ?? false;
	let stage_participations = { summary:[], total:0 };
	const [ all_participations, setAllParticipations ] = useState({ summary:[] });
	const [ display_multistage_details_layer, setDisplayMultistageDetailsLayer ] = useState(false);
	const [ loading_multistage_data, setLoadingMultistageData ] = useState(true);
	const [ fb_config, setFbConfig ] = useState(false);
	const [ display_upload_msg, setDisplayUploadMsg ] = useState(false);
	const [ total, setTotal ] = useState(0);
	const [ has_quiz_stages, setHasQuizStages ] = useState(false);
	const [ has_game_stages, setHasGameStages ] = useState(false);
	const [ has_voting_stages, setHasVotingStages ] = useState(false);
	const [ has_team_stages, setHasTeamStages ] = useState(false);
	const [ has_form_stages, setHasFormStages ] = useState(false);
	const [ has_guess_score_stages, setHasGuessScoreStages ] = useState(false);

	const register_info = _participations.find((p) => p.User.stage == 0);
	const passed_participations = _participations.filter((p) => p.User.stage != 0);
	if(!passed_participations) passed_participations = [];

	const stages = (props.stages != undefined) ? Object.values(props.stages) : {};

	const findStageById = (id) => {
		return stages.find((obj) => { return obj.Stage.id == id; });
	};

	const getParticipations = () => {
		let order_stages = {};
		let i = 1;

		let _part = {...all_participations};

		passed_participations.map((part) => {
			let this_stage = findStageById(part.User.stage);

			if(this_stage != undefined && this_stage.Stage != undefined) {
				this_stage = this_stage.Stage;

				const is_game = (this_stage?.is_game ?? false) || (this_stage?.is_new_game ?? false);
				if(is_game && !has_game_stages) setHasGameStages(true);

				const is_quiz = this_stage?.is_quiz ?? false;
				if(is_quiz && !has_quiz_stages) setHasQuizStages(true);

				const is_voting = this_stage?.is_voting ?? false;
				if(is_voting && !has_voting_stages) setHasVotingStages(true);

				const is_team = this_stage?.is_team ?? false;
				if(is_team && !has_team_stages) setHasTeamStages(true);

				const is_form = this_stage?.is_form ?? false;
				if(is_form && !has_form_stages) setHasFormStages(true);

				const is_guess_score = ([spt.SCORE_PREDICTOR.id].includes(parseInt(this_stage.promotion_type_id))) ? true : false;
				if(is_guess_score && !has_guess_score_stages) setHasGuessScoreStages(true);

				if(order_stages[this_stage.id] == undefined) {
					order_stages[this_stage.id] = i;
					i++;
				}
				let _p = {
					Stage:{
						display_title:this_stage.display_title,
						is_game,
						is_quiz,
						is_voting,
						is_team,
						is_form,
						is_guess_score,
						order:order_stages[this_stage.id],
					},
					StageScore:{
						id:part.User.id,
						created:part.User.created,
						data:`${part.User.first_name} ${part.User.last_name}`,
						login_id:part.User.login_id,
						modified:part.User.modified,
						quiz_entry:part.User.quiz_entry,
						score:part.User.quiz_result,
						stage_id:part.User.stage,
						locale:part.User.keyword,
						public_entry:part.User.public_entry,
						share_data:part.User?.share_data ?? false,
						votable_gallery:part.User?.votable_gallery ?? false,
					},
				};

				if (props.stats && props.stats[part.User.stage]) {
					_p.stats = props.stats[part.User.stage];
				}

				if(this_stage.team_candidates != undefined) _p.Stage.team_candidates = this_stage.team_candidates;
				if(this_stage.team_sections != undefined) _p.Stage.team_sections = this_stage.team_sections;
				if(part?.User?.extra?.stage_ticket?.graphic_info){
					_p.StageTicket = part.User.extra.stage_ticket;
					if(part?.User?.extra?.stage_ticket?.ticket_extra_data)_p.Stage.reqs_form = this_stage.reqs_form;
				}
				_part.summary.push(_p);
			}
		});
		if(register_info.User.login_id != undefined) {
			$.get(getRemotedbUrl(`/users/entry_summary/${promotion.id}/?id=${register_info.User.login_id}`), (res) => {
				stage_participations = res;
				setTotal(res.total);
				setAllParticipations(_part);
				setLoadingMultistageData(false);
			}, 'JSON');
		}
	}

	const toggleXeerpa = () => {
		if(fb_config === false) {
			$.get(`/promotions/discovery/${promotion.id}`, (response) => {
				setFbConfig(response.html);
			}, 'JSON');
		} else {
			setFbConfig(false);
		}
	};

	const toggleMultiStageDetails = () => {
		setDisplayMultistageDetailsLayer(!display_multistage_details_layer);
	};

	const onChangeAvatar = () => {
		setDisplayUploadMsg("The changes may take a few minutes to apply");
	}

	const displayed_name = (register_info.User.name != undefined && register_info.User.name != "") ? register_info.User.name : `${register_info.User.first_name} ${register_info.User.last_name}`;

	const is_loaded = (stage_participations.total != undefined && !loading_multistage_data) ? true : false;

	const has_ranking_enabled = (promotion.public_entries != '0') ? true : false;

	useEffect(() => {
		getParticipations();
	}, []);

	if(promotion === false) return null;

	if(fb_config !== false) {
		return (
			<XeerpaDiscovery data={state.fb_config} close={toggleXeerpa} />
		)
	}

	const is_unsubscribed = register_info?.User?.unsubscribe_info ?? false;
	const has_avatar = register_info.User?.avatar ?? false;
	const is_blocked_avatar = (has_avatar !== false && has_avatar.indexOf('blocked') > -1) ? true : false;
	const is_visitor = (register_info.User.net_type == 7) ? true : false;

	const has_loyalty_program = promotion?.loyalty_enabled ?? false;
	const hide_prizes = promotion?.layout_props?.header?.hide_won_prizes_in_header ?? false;

	return (
		<>
			{(display_upload_msg !== false) && (
				<Message
					title={display_upload_msg}
					_class={{ other:'in_top' }}
					custom_styles={{ '--h2-color':'255, 255, 255, 1' }}
				/>
			)}

			<div class="gui_my_participation gui_main_text_color_on_bg">
				<div class="registration_info">
					<div>
						{(!is_blocked_avatar) ? (
							<UploadAvatar
								onChangeAvatar={onChangeAvatar}
								user={register_info.User}
								width={90}
								height={90}
								display_network_icon={true}
							/>
						) : (
							<UserAvatar
								user={register_info.User}
								width={6.75}
								height={6.75}
								display_network_icon={true}
							/>
						)}
					</div>

					<article class="participation_info main_text_flex">
						<LeveledHTMLText
							is_text_block={false}
						>
							<h1 class="full_name">{displayed_name}</h1>

							<p class="relevant_dates">
								<span class="knk-add-user gui_small_icon">{i18n("Registered on")}: {moment.tz(register_info.User.created, 'Europe/Madrid').tz(promotion.timezone).format('llll')}</span>

								{(is_unsubscribed !== false) && (
									<span class="knk-email gui_small_icon">{i18n("Unsubscribed on")}: {moment.tz(is_unsubscribed.created, 'Europe/Madrid').tz(promotion.timezone).format('ll')} (<ActionLink _href={`/emails/resubscribe/${is_unsubscribed.id}/${is_unsubscribed.hash}`} _target="_blank">Subscribe again</ActionLink>)</span>
								)}
							</p>
						</LeveledHTMLText>

						<div class="logout">
							<ActionLink
								_href={`/promotions/logout/${promotion.id}`}
								icon='knk-logout'
							>Logout</ActionLink>
						</div>

						{(props.xeerpa && register_info.User.net_type == 1) && (
							<div id="xeerpa_btn" class="solid_buttons">
								<div class="flex_button gui_xeerpa_button gui_custom_color">
									<ActionButton
										icon='ep-facebook'
										_href={`/promotions/my_fb_config/${register_info.User.promotion_id}`}
									>My Facebook Preferences</ActionButton>
								</div>
							</div>
						)}
					</article>
				</div>
				
				{(is_loaded) ? (
					<div class="stage_info">
						{(all_participations.summary.length > 0) ? (
							<div>
								{(parseInt(props?.total_prizes ?? '0') > 0 && !hide_prizes && !is_visitor) && (
									<p>
										<ActionLink
											_href={`/my_prizes/${promotion.id}`}
										>View my prizes</ActionLink> ({props.total_prizes})</p>
								)}

								{(has_loyalty_program) && (
									<p class="gui_not_in_top_small">
										<ActionLink
											_href={`/loyalty/my_rewards/${promotion.id}`}
											autotranslate={false}
										>{props.intl.formatMessage({ id:"View my {coin_name} history" }, { coin_name:formatTokenTitle(Object.values(props.loyalty.tokens)[0].LoyaltyToken, 2)})}</ActionLink>
									</p>
								)}

								<div class="participations_info">
									{(has_ranking_enabled) && (
										<div class="user_total_score">
											{i18n("Total points")}: {formatNumber(total)} [<ActionLink onClick={() => toggleMultiStageDetails()}>View</ActionLink>]
										</div>
									)}

									<UserParticipationsMultistageList
										stage_participations={all_participations}
										promotion={promotion}
										stages={stages}
										has_game_stages={has_game_stages}
										has_quiz_stages={has_quiz_stages}
										has_voting_stages={has_voting_stages}
										has_team_stages={has_team_stages}
										has_form_stages={has_form_stages}
										has_guess_score_stages={has_guess_score_stages}
										display_complete_info={true}
										display_date={true}
										total_participations={props.total_participations}
										username={displayed_name}
										locale={props.locale}
									/>
								</div>
							</div>
						) : (
							<div>{i18n("You have not participated yet.")}</div>
						)}
					</div>
				) : (
					<Spinner>{`${i18n("Loading data")}...`}</Spinner>
				)}

				{(display_multistage_details_layer) && (
					<FloatingLayerPublic
						pm={promotion}
						title={`<h1>${isNotEmpty(register_info.User, 'first_name') ? register_info.User.first_name : displayed_name}</h1><p>${i18n("Total")}: ${formatNumber(total)}</p>`}
						backButton={() => toggleMultiStageDetails()}
					>
						<UserParticipationsMultistageList
							stage_participations={all_participations}
							promotion={promotion}
							username={displayed_name}
						/>
					</FloatingLayerPublic>
				)}
			</div>
		</>
	)
}

export default injectIntl(MyParticipationMultistage);